import { useNavigate, useParams } from "react-router-dom";

import { HistoryState } from "src/types";
import { removeAllDrawnLayers } from "src/utils/map.utils";
import { Pane } from "src/components/Pane";
import { TrafficEmissionSegmentBulkEditPage } from "./TrafficEmissionSegmentBulkEditPage";
import { TrafficEmissionSegmentCreatePage } from "./TrafficEmissionSegmentCreatePage";
import { TrafficEmissionSegmentEditPage } from "./TrafficEmissionSegmentEditPage";
import { Suspense } from "react";
import { PaneLoader } from "src/components/loaders/PaneLoader";
import { useTranslation } from "react-i18next";

interface Props {
  map: L.Map;
}

export function TrafficEmissionSegmentPage(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams<{
    caseId: string;
    scenarioId: string;
    emissionId: string;
    segmentId: string;
  }>();

  function handleClose(action?: HistoryState["action"]) {
    removeAllDrawnLayers(props.map);
    const url = `/cases/${params.caseId}/scenarios/${params.scenarioId}/emissions/traffic/${params.emissionId}`;
    navigate(url, { state: { action } });
  }

  return render();

  function render() {
    if (params.segmentId === "new") {
      return (
        <Suspense fallback={<PaneLoader message={t("label.loading")} />}>
          <Pane>
            <TrafficEmissionSegmentCreatePage onClose={handleClose} map={props.map} />
          </Pane>
        </Suspense>
      );
    } else if (params.segmentId === "bulk") {
      return (
        <Suspense fallback={<PaneLoader message={t("label.loading")} />}>
          <Pane>
            <TrafficEmissionSegmentBulkEditPage onClose={handleClose} map={props.map} />
          </Pane>
        </Suspense>
      );
    } else {
      return (
        <Suspense fallback={<PaneLoader message={t("label.loading")} />}>
          <Pane>
            <TrafficEmissionSegmentEditPage key={Object.values(params).join()} onClose={handleClose} map={props.map} />
          </Pane>
        </Suspense>
      );
    }
  }
}
